export default "__VITE_ASSET__CMRztUDN__"